export const HIDE_INLINE_NOTIFICATION_EXPIRY =
  new Date().getTime() + 6 * 30 * 24 * 60 * 60 * 1000; // 6 months
